<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Create Calamity</v-card-title>
          <v-card-text>
            <div>
              Creating calamity for {{this.selectedPotentialPackages.filter(x => x.selected).length}} out of {{this.selectedPotentialPackages.length}}
              <v-select class="calamity-reason-select" :items="calamityReasons" v-model="selectedCalamityReason"></v-select>
              <v-text-field class="calamity-reason-text" v-if="otherIsSelected()" label="Calamity Reason" v-model="title" :counter="10" required></v-text-field>
            </div>
            <div style="text-align:center">
              <v-progress-circular v-show="loading" indeterminate color="primary"></v-progress-circular>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text :disabled="loading" class="cancel-create-calamity-btn" @click="dialog=false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" class="create-calamity-btn" @click="create()" text>Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <a @click="goBack()">Back</a>
    <v-card>
      <v-responsive>
        <v-container grid-list-md text-xs-left>
          <v-layout row wrap>
            <v-flex xs6>
              <v-card flat>
                <v-card-text class="pl-10">
                  <v-layout class="transit-state-filter transit-state-filter-btn" row v-for="i in selectGroups()" @click="filterByTransit(i.key)" :key="i.key">
                    <v-icon :class="getTransitClass(i.key, true)">label</v-icon>
                    <v-flex xs4>{{i.key}}</v-flex>
                    <v-flex class="transit-state-filter-total" xs3>{{i.items.length}}</v-flex>
                  </v-layout>
                  <v-layout class="transit-state-clear-filter" row @click="filterByTransit(null)">
                    <v-icon>label</v-icon>
                    <v-flex xs4>Total</v-flex>
                    <v-flex xs3>{{selectedPotentialPackages.length}}</v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-responsive>
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">{{selectedPotential.CurrentCity}},{{selectedPotential.CurrentState}}</h3>
          {{selectedCount}} selected out of {{selectedPotentialPackages.length}}
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn text color="orange" class="select-all-btn" @click="selectAll()">Add {{filterCount()}}</v-btn>
        <v-btn text color="orange" class="clear-all-btn" @click="clearAll()">Clear </v-btn>
        <v-btn text color="orange" class="create-calamity-dialog-btn" :disabled="selectedPotentialPackages.filter(x => x.selected).length === 0" @click="showSaveDialog()">Create Calamity</v-btn>
      </v-card-actions>
    </v-card>
    <v-data-table :mobile-breakpoint="0" disable-pagination hide-default-footer class="potential-packages-data-table no-wrap-th" :items="filteredItems" item-key="PackageId" :headers="headers" :loading="loading">
      <template v-slot:item="{ item }" item-key="HashKey">
        <tr :class="item.ProtectionState" class="potential-package">
          <td><v-checkbox class="select-cb" v-model="item.selected"></v-checkbox></td>
          <td>
            <div class="tracking-link" style="display: flex;">{{item.TrackingNumber}}<a :href="getTrackingUrl(item.TrackingNumber, item.CarrierId)" target="_blank" style="text-decoration: none; margin-left: 5px;"  v-if="getTrackingUrl(item.TrackingNumber, item.CarrierId)">
                <v-icon style="font-size: 20px;">near_me</v-icon>
              </a>
            </div>
          </td>
          <td>
            <v-chip :class="getTransitClass(item.TransitState)">{{item.TransitState.match(/\b\w/g).join("")}}</v-chip>
          </td>
          <td>
            {{item.LastActivity}}
          </td>
          <td>
            {{item.ServiceDesc}}
          </td>
          <td>
            {{item.State}}
          </td>
          <td>
            {{item.ScheduledDeliveryDate | formatWholeDate}}
          </td>
          <td>
            {{item.OriginalScheduledDeliveryDate | formatWholeDate}}
          </td>
          <td>
            {{item.RootCauseCode}}
          </td>
        </tr>
      </template>
    </v-data-table>

  </div>
</v-slide-y-transition>
</v-container>
<!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import { POTENTIAL_CALAMITY_NAMESPACE } from "./store/potentialCalamityStore";
export default {
  name: "PotentialCalamitiesDetail",
  data() {
    return {
      title: null,
      selectedCalamityReason: null,
      calamityReasons: [
        "Mechanical Failure",
        "Late Plane",
        "Operational Delay",
        "Severe Weather",
        "Other"
      ],
      dialog: false,
      filter: null,
      headers: [
        {
          text: "Add",
          value: "selected",
          sortable: false,
          align: "left",
          width: 20
        },
        {
          text: "TrackingNumber",
          value: "TrackingNumber",
          align: "left"
        },
        {
          text: "Transit",
          value: "LastActivity",
          align: "left"
        },
        {
          text: "Transit Status",
          value: "TransitStatus",
          align: "left"
        },
        {
          text: "Shipping Service",
          value: "ServiceDesc",
          align: "left"
        },
        {
          text: "Dest. State",
          value: "State",
          align: "left"
        },
        {
          text: "Scheduled For",
          value: "ScheduledDeliveryDate",
          align: "left"
        },
        {
          text: "Originally Scheduled For",
          value: "OriginalScheduledDeliveryDate",
          align: "left"
        },
        {
          text: "Root Cause",
          value: "RootCauseCode",
          align: "left"
        }
      ],
      transitClasses: {
        "In Transit": "InTransitState",
        "At Sort": "AtSortState",
        "At Destination": "AtDestinationState",
        "Out For Delivery": "OutForDeliveryState",
        Delivered: "DeliveredState",
        Manifested: "ManifestedState"
      }
    };
  },
  computed: {
    ...mapGetters(POTENTIAL_CALAMITY_NAMESPACE, [
      "selectedPotential",
      "selectedPotentialPackages",
      "loading"
    ]),
    filteredItems() {
      if (this.filter == null) {
        return this.selectedPotentialPackages;
      } else {
        return this.selectedPotentialPackages.filter(
          x => x.TransitState === this.filter
        );
      }
    },
    selectedCount() {
      return this.selectedPotentialPackages.filter(x => x.selected).length;
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.CALAMITY_ADMIN]).then(
      res => {
        if (res) {
          this.loadPotentialCalamityPackages();
        } else this.$goHome();
      }
    );
  },
  methods: {
    otherIsSelected() {
      if (
        this.selectedCalamityReason &&
        this.selectedCalamityReason === "Other"
      )
        return true;
      else return false;
    },
    showSaveDialog() {
      this.dialog = true;
    },
    create() {
      let title =
        this.selectedCalamityReason === "Other"
          ? this.title
          : this.selectedCalamityReason;
      let calamity = {
        title: title,
        packages: this.selectedPotentialPackages
          .filter(x => x.selected)
          .map(x => x.PackageId),
        locationId: this.selectedPotential.LocationId,
        clientId: this.selectedPotential.ClientId
      };
      return this.$store
        .dispatch(`${POTENTIAL_CALAMITY_NAMESPACE}/CREATE`, calamity)
        .then(res => {
          this.dialog = false;
          this.$router.push({ path: `/calamities` });
          return calamity;
        });
    },
    filterCount() {
      if (this.filter == null) {
        return "All";
      } else {
        return this.selectedPotentialPackages
          .filter(x => x.TransitState === this.filter)
          .length.toString();
      }
    },
    getTransitClass(transit, isIcon) {
      var transitClass = "OtherState";
      if (this.transitClasses[transit])
        transitClass = this.transitClasses[transit];
      if (isIcon) transitClass += "-icon";
      return transitClass;
    },
    selectGroups() {
      return _.chain(this.selectedPotentialPackages)
        .groupBy("TransitState")
        .toPairs()
        .map(function(currentItem) {
          return _.zipObject(["key", "items"], currentItem);
        })
        .value();
    },
    selectAll() {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_NAMESPACE}/SELECT_ALL`,
        this.filter
      );
    },
    clearAll() {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_NAMESPACE}/CLEAR_ALL`,
        this.filter
      );
    },
    filterByTransit(lbl) {
      this.filter = lbl;
    },
    goBack() {
      this.$router.go(-1);
    },
    loadPotentialCalamityPackages() {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_NAMESPACE}/LOAD_POTENTIAL_PACKAGES`,
        this.selectedPotential.HashKey
      );
    },
    getTrackingUrl(trackingNumber, carrierId) {
      switch (carrierId) {
        // UPS
        case 1:
          return (
            "http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=" +
            trackingNumber
          );
        // FEDEX
        case 2:
          return (
            "http://www.fedex.com/Tracking?action=track&tracknumbers=" +
            trackingNumber
          );
        // GSO
        case 3:
          return (
            "https://www.gso.com/Trackshipment?TrackingNumbers=" +
            trackingNumber
          );
        // USPS
        case 13:
          return (
            "https://tools.usps.com/go/TrackConfirmAction?tLabels=" +
            trackingNumber
          );
      }
      return false;
    }
  }
};
</script>
